"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bi = require("react-icons/bi");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../../Button/Button"));

var _GAIA_label = _interopRequireDefault(require("../../images/GAIA_label.svg"));

var _reactBootstrap = require("react-bootstrap");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatbotHeader = function ChatbotHeader(_ref) {
  var clearChatLog = _ref.clearChatLog,
      isClearChatActive = _ref.isClearChatActive;

  var handleClearLog = function handleClearLog(event) {
    event.preventDefault();
    clearChatLog();
  };

  var tooltipClear = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
    id: 123
  }, "Limpiar chat"); // - Separar ventana - En Progreso - const tooltipOpenWindow = <Tooltip id={124}>Separar chat</Tooltip>;


  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chatbotHeader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "chatbotHeader-title"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _GAIA_label.default,
    style: {
      height: '30px'
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    placement: "top",
    overlay: tooltipClear
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "chatbotHeader-closeButton"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "chatbotHeader-closeButton",
    disabled: !isClearChatActive,
    icon: _bi.BiTrash,
    sizeIcon: "25px",
    type: "reset",
    onClick: handleClearLog,
    variant: "primary",
    widthButton: "40px"
  }))));
};

ChatbotHeader.propTypes = {
  title: _propTypes.default.string
};
ChatbotHeader.defaultProps = {
  title: ''
};
var _default = ChatbotHeader;
exports.default = _default;